import { ClientPortalTaskComment, ClientPortalTaskCommentsGroup } from '../../types';

export const getInitials = (name: string) =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');

export const mapClientPortalTaskComments = (
  taskComments?: ClientPortalTaskCommentsGroup[],
): Record<string, ClientPortalTaskComment[]> =>
  (taskComments || []).reduce<Record<string, ClientPortalTaskComment[]>>((acc, item) => {
    acc[item.taskId] = item.comments || [];
    return acc;
  }, {});
